import { RootState } from "app/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UsersState {
  lastViewedUser: string | null;
}

const initialState: UsersState = {
  lastViewedUser: null,
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setLastViewedUser: (state, action: PayloadAction<string | null>) => {
      state.lastViewedUser = action.payload;
    },
  },
});

export const { setLastViewedUser } = usersSlice.actions;

export const selectLastViewedUser = (state: RootState) => state.users.lastViewedUser;

export default usersSlice.reducer;
